import React, { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import TopNav from '../Landing/TopNav'
import SideNav from '../Landing/SideNav'
import { useAuth } from '../../contexts/AuthContext'

const DashboardLayout = () => {
  const { user } = useAuth()
  const [sideNavCollapsed, setSideNavCollapsed] = useState(false)
  const location = useLocation()

  // Extract the current route from the pathname
  const getCurrentTab = () => {
    const path = location.pathname
    if (path === '/dashboard' || path === '/dashboard/') {
      return 'my-templates' // Default to my templates
    }
    const segments = path.split('/')
    const route = segments[2] || 'templates'
    
    // Map route to tab ID
    const routeToTabMap = {
      'templates': 'templates',
      'my-templates': 'my-templates',
      'all-templates': 'all-templates',
      'categories': 'category-management',
      'photos': 'photos',
      'graphics': 'graphics',
      'audio': 'audio',
      'videos': 'videos',
      'tenants': 'tenant-management',
      'users': 'user-management',
      'template-assignments': 'tenant-template-management',
      'manage-templates': 'template-management',
      'multi-template-generator': 'multi-template-generator',
      'font-preview': 'font-preview',
      'developer-api': 'developer-api'
    }
    
    return routeToTabMap[route] || 'my-templates'
  }

  const currentTab = getCurrentTab()

  const handleTabChange = (tab) => {
    // This will be handled by the router navigation in SideNav
  }

  const isAdmin = user?.role === 'ADMIN'

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top Navigation */}
      <TopNav onMenuToggle={() => setSideNavCollapsed(!sideNavCollapsed)} />

      <div className="flex h-[calc(100vh-64px)]">
        {/* Side Navigation */}
        <SideNav
          isCollapsed={sideNavCollapsed}
          onToggle={() => setSideNavCollapsed(!sideNavCollapsed)}
          activeTab={currentTab}
          onTabChange={handleTabChange}
          isAdmin={isAdmin}
        />

        {/* Main Content Area */}
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default DashboardLayout
